import { render, staticRenderFns } from "./leader-sch.vue?vue&type=template&id=672d3949&scoped=true"
import script from "./leader-sch.vue?vue&type=script&lang=js"
export * from "./leader-sch.vue?vue&type=script&lang=js"
import style0 from "./leader-sch.vue?vue&type=style&index=0&id=672d3949&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672d3949",
  null
  
)

export default component.exports